export * from './intlHelpers'
export * from './inputFormatters'
export * from './intlTestHelpers'
export * from './regexConstants'
export * from './delayFn'
export * from './featureFlags'
export * from './textGenerator'
export * from './dataDisplayFormatters'
export * from './formatAddress'
export * from './convertToValidDate'
export * from './layoutConstants'
export * from './getAccountNames'

//Get a setting (by key) from window.APP_CONFIG (from config.js).
//If the setting does not exist, return an optional defaultValue or undefined.
export function getAppConfigSetting(key: string, defaultValue?: string) {
  // @ts-ignore
  const config = typeof window !== 'undefined' ? window.appConfig || {} : {}
  let value
  if (key in config) {
    //config keys are allowed to have mustache template values referencing APP_CONFIG
    value = config[key]
  }
  return value === undefined ? defaultValue : value
}
